import createPersistedState from 'vuex-persistedstate'
import Vue from 'vue'
import Vuex from 'vuex'

import app from '@/store/app'
import auth from '@/store/auth'
import likedServers from '@/store/likedServers'
import notifications from '@/store/notifications'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    auth,
    likedServers,
    notifications,
  },

  plugins: [
    createPersistedState({
      paths: [
        'auth.token',
      ],
    }),
  ],
})

export default store
